import React, { FC } from "react"
import { RouteComponentProps } from "@reach/router"
import _ from "lodash"
import toggles from 'feature-toggles'
import Subnav from "components/subnav"
import { Container_s, Content_s } from "styles/app-styles"

interface Route {
  hard?: boolean,
  name: string,
  link: string
}

const TenantMarket: FC<RouteComponentProps> = (props) => {
  let tabs: Route[] = [
    {link: '/n/tenant-market/rent', name: 'Rent'},
    {link: '/n/tenant-market/free-rent', name: 'Free Rent'},
    {link: '/n/tenant-market/increase', name: 'Increase'},
    {link: '/n/tenant-market/tenant-improvement', name: 'TI'},
    {link: '/n/tenant-market/leasing-commissions', name: 'LC'},
    {link: '/n/tenant-market/other-capital', name: 'Other Capital'},
    {link: '/n/tenant-market/payout', name: 'Payout'}
  ]

  return (
    <Container_s>
      <Subnav section="TENANT MARKET" tabs={tabs}/>
      <Content_s>
        {props.children}
      </Content_s>
    </Container_s>
  )
}

export default TenantMarket
